import { Navigate, useLocation } from 'react-router-dom';
import { ReactNode } from 'react';

interface Props {
  jwt: string | null;
  loginPath: string;
  children: ReactNode;
}

export function RequireAuth({ jwt, loginPath, children }: Props) {
  const location = useLocation();
  if (!jwt) {
    return <Navigate to={loginPath} state={{ from: location }} replace />;
  }
  return <>{children}</>;
}
